// extracted by mini-css-extract-plugin
module.exports = {"resolutionNotSupportedContainer":"UnsupportedResolution_resolutionNotSupportedContainer__BiFn7"};